import cn from 'classnames';
import { useAuthContext } from '@lp/core/auth';
import { ReservationCell } from '@lp/features/Scheduler/components';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { getCSShiftColors } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/utils';
import { shiftTimeGroupNames, shiftTypeNames } from '@/constants/schedule.constants';
import { ReservationNode } from '@/api/apis/resources';
import { CSShift } from '@/api/apis/resources/schedule';
import { SchedulerPermissions } from '@/permissions';
import { CaseResourceType } from '@/api/apis/case';

type CSReservationCellProps = {
  column: SchedulerDayColumn;
  shiftData?: CSShift;
  reservations?: ReservationNode[];
};

export const CSReservationCell = ({ column, shiftData, reservations }: CSReservationCellProps) => {
  const { checkPermission } = useAuthContext();
  const colors = getCSShiftColors(shiftData);

  const hasEditPermission = checkPermission(SchedulerPermissions.CSSchedulesRestPeriodWrite);

  return (
    <ReservationCell
      column={column}
      reservations={reservations}
      isRestReadOnly={!hasEditPermission}
      resourceType={CaseResourceType.ClinicalSpecialist}
    >
      {shiftData && (
        <span className={cn(colors.icon, 'text-xs-r')}>
          {shiftTypeNames[shiftData.shiftType]}
          {shiftData.timeGroup && ` · ${shiftTimeGroupNames[shiftData.timeGroup]}`}
        </span>
      )}
    </ReservationCell>
  );
};
